import React from "react";
import { Box, Typography } from "@mui/material";
import { formatCurrencyManual } from "../../utils/formatters";
import { Num } from "../../components/ui";
import { tokens } from "../../theme";

/**
 * Los cuatro números del recibo. La grilla se acomoda sola: en teléfono caen
 * de a uno o dos por fila y nunca obligan a scrollear de lado.
 */
const Totals = ({ totalExpensesWithIva, totalPaymentMethods, totalBalance, usedBalance }) => {
  const totalToPay = parseFloat((Number(totalExpensesWithIva || 0) - Number(totalPaymentMethods || 0)).toFixed(2));
  const excedente = totalToPay < 0 ? Math.abs(totalToPay) : 0;
  const newBalance = Number(totalBalance || 0) - Number(usedBalance || 0) + excedente;
  const pendiente = totalToPay < 0 ? 0 : totalToPay;

  const items = [
    { label: "Total Facturas Seleccionadas", value: Number(totalExpensesWithIva || 0) },
    { label: "Total de las Formas de Pago", value: Number(totalPaymentMethods || 0) },
    { label: "Saldo a Cancelar", value: pendiente, destacado: true },
    { label: "Nuevo Saldo a Favor", value: newBalance },
  ];

  return (
    <Box
      sx={{
        /*
          Queda fijo debajo de la barra superior mientras se cargan las formas
          de pago, así el Saldo a Cancelar siempre está a la vista. La barra
          mide 56 px en teléfono y 64 en escritorio.
        */
        position: "sticky",
        top: { xs: "56px", md: `${tokens.topbarHeight}px` },
        zIndex: 10,
        backgroundColor: tokens.canvas,
        paddingTop: "8px",
        paddingBottom: "8px",
        marginTop: "-8px",
        display: "grid",
        // minmax chico para que las cuatro fichas entren siempre, también en teléfono.
        gridTemplateColumns: { xs: "repeat(2, minmax(0, 1fr))", md: "repeat(4, minmax(0, 1fr))" },
        gap: { xs: "8px", md: "10px" },
        width: "100%",
        minWidth: 0,
      }}
    >
      {items.map(({ label, value, destacado }) => (
        <Box
          key={label}
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "5px",
            minWidth: 0,
            padding: { xs: "11px 12px", md: "12px 14px" },
            borderRadius: `${tokens.radiusCard}px`,
            border: `1px solid ${destacado ? tokens.brandBorder : tokens.border}`,
            backgroundColor: destacado ? tokens.brandTint : tokens.surface,
          }}
        >
          <Typography
            sx={{
              fontSize: "11.5px",
              fontWeight: 500,
              color: destacado ? tokens.brandDarker : tokens.ink3,
              lineHeight: 1.3,
            }}
          >
            {label}
          </Typography>
          <Num
            sx={{
              fontSize: { xs: "15px", md: "16.5px" },
              fontWeight: 600,
              lineHeight: 1.15,
              minWidth: 0,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              color: destacado ? tokens.brandDarker : tokens.ink,
            }}
            title={formatCurrencyManual(value)}
          >
            {formatCurrencyManual(value)}
          </Num>
        </Box>
      ))}
    </Box>
  );
};

export default Totals;
